export default __webpack_public_path__ + "static/SRC 4400 - Product Specifications & Technical Data-1303fc8433b8957c796ebbf456557d21.pdf";